import { Reducer } from 'redux';
import { getType } from '@anm/helpers/saga/typesafe-actions';

import { initialVideoFolderState } from '..';
import { deleteFolderAsync } from '../../actions';
import { removeFolder } from '../../helpers';
import { VideoFolderActions } from '../../types';

const deleteFolderReducer: Reducer<
  typeof initialVideoFolderState,
  VideoFolderActions
> = (state = initialVideoFolderState, action) => {
  switch (action.type) {
    case getType(deleteFolderAsync.request): {
      const params = action.payload;
      return {
        ...state,
        deleteFolder: {
          ...state.deleteFolder,
          params,
          isError: false,
          isPending: true
        }
      };
    }
    case getType(deleteFolderAsync.success): {
      const { params } = state.deleteFolder;
      return {
        ...state,
        data: removeFolder(state.data!, params!.folderId),
        folderTree: {
          ...state.folderTree,
          data: removeFolder(state.folderTree.data!, params!.folderId)
        },
        deleteFolder: {
          ...state.deleteFolder,
          isPending: false
        }
      };
    }
    case getType(deleteFolderAsync.failure): {
      const error = action.payload;

      return {
        ...state,
        deleteFolder: {
          ...state.deleteFolder,
          error,
          isError: true,
          isPending: false
        }
      };
    }
    default:
      return state;
  }
};

export default deleteFolderReducer;
